import { FormLabel } from '@mui/material';
import React from 'react';

type Props = {
  children: React.ReactNode;
  id?: string;
};

function UiFormLabel({ children, ...rest }: Props) {
  return (
    <FormLabel
      {...rest}
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {children}
    </FormLabel>
  );
}

export default UiFormLabel;
